import {SVGProps} from "types/SVG";

export const DamageAngle = ({alt, className}: SVGProps) => (
    <svg width="165" height="165" viewBox="0 0 165 165" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <title>{alt}</title>
        <g clip-path="url(#clip0_3545_20718)">
            <path d="M165.073 76.9551H-0.0722656V165.082H165.073V76.9551Z" fill="url(#paint0_linear_3545_20718)"/>
            <mask id="mask0_3545_20718" maskUnits="userSpaceOnUse" x="-1" y="-1" width="167"
                  height="167">
                <path d="M165.073 -0.078125H-0.0722656V165.08H165.073V-0.078125Z" fill="white"/>
            </mask>
            <g mask="url(#mask0_3545_20718)">
                <path
                    d="M166.38 -1.99023H8.96677C2.9571 -1.99023 -1.91406 2.88277 -1.91406 8.8906V67.7003L166.38 108.503V-1.99023Z"
                    fill="url(#paint1_linear_3545_20718)"/>
                <path
                    d="M38.3859 112.966L65.4093 114.017L81.4674 99.5553L53.1534 70.3301L38.8113 80.1567L34.3984 102.236L38.3859 112.966Z"
                    fill="#2C3E54"/>
                <path
                    d="M88.1477 97.0724C79.8464 85.2437 67.7005 80.8419 59.1169 85.7956C57.8537 86.5234 50.3389 91.1379 48.5679 92.2471C47.4862 92.9254 46.4632 93.7596 45.519 94.7514C37.0564 103.638 37.9144 121.841 47.4367 135.409C55.4704 146.858 67.1065 151.348 75.6297 147.135C75.7947 147.053 76.3227 146.759 76.3227 146.759C76.3227 146.759 85.372 141.25 86.9359 140.284C88.0487 139.597 89.0974 138.748 90.0654 137.73C98.528 128.844 97.67 110.641 88.1477 97.0724Z"
                    fill="#37556D"/>
                <path
                    d="M74.9763 147.431C85.7826 142.734 89.0732 126.342 82.3262 110.817C75.5791 95.2926 61.3493 86.5147 50.5431 91.2111C39.7368 95.9076 36.4461 112.3 43.1932 127.825C49.9402 143.349 64.17 152.127 74.9763 147.431Z"
                    fill="#4B6C8C"/>
                <path
                    d="M71.3866 139.171C79.018 135.854 81.3419 124.278 76.5772 113.315C71.8125 102.352 61.7636 96.1527 54.1322 99.4693C46.5009 102.786 44.177 114.362 48.9416 125.325C53.7063 136.288 63.7553 142.487 71.3866 139.171Z"
                    fill="#37556D"/>
                <path
                    d="M67.051 140.866C66.7229 140.866 66.3929 140.855 66.0574 140.829C60.704 140.43 55.3159 136.899 51.2789 131.144C44.3562 121.281 43.7824 107.943 50.001 101.415C52.5072 98.7819 55.7815 97.5352 59.4592 97.8084C64.8144 98.2081 70.2007 101.737 74.2414 107.494C81.164 117.357 81.7379 130.695 75.5192 137.223C73.2385 139.618 70.3272 140.866 67.051 140.866ZM58.482 99.3832C55.6495 99.3832 53.136 100.459 51.1689 102.526C45.4544 108.526 46.0942 120.951 52.5989 130.218C56.3022 135.496 61.3787 138.862 66.1784 139.222C69.3574 139.453 72.188 138.384 74.3532 136.112C80.0677 130.112 79.4279 117.687 72.9232 108.42C69.218 103.142 64.1415 99.7756 59.3419 99.4162C59.0522 99.3942 58.7662 99.3832 58.4839 99.3832H58.482Z"
                    fill="url(#paint2_linear_3545_20718)"/>
                <path
                    d="M66.0498 126.892C68.9601 125.627 69.8461 121.212 68.0288 117.03C66.2115 112.849 62.379 110.484 59.4687 111.749C56.5585 113.014 55.6725 117.429 57.4898 121.61C59.3071 125.792 63.1396 128.156 66.0498 126.892Z"
                    fill="#4B6C8C"/>
                <path
                    d="M129.689 144.222C129.689 144.222 126.881 144.321 123.269 144.081C120.871 143.922 118.891 141.975 115.565 141.57C113.021 141.26 110.894 141.846 108.082 141.335C106.749 141.093 104.171 140.4 102.818 140.103C101.062 139.718 99.4484 140.29 97.7049 139.806C93.6716 138.684 90.8867 134.845 90.8867 130.498L133.902 139.256"
                    fill="#7196B5"/>
                <path
                    d="M191.423 104.387L191.59 105.824C191.784 107.483 191.066 110.044 189.839 111.124C184.684 115.667 178.24 119.589 164.26 129.087C159.662 132.211 153.218 136.466 147.506 139.101C140.565 142.302 136.005 143.437 129.686 144.221L134.564 137.293L191.421 104.387H191.423Z"
                    fill="#7196B5"/>
                <path
                    d="M91.5721 133.643L110.301 138.934C113.233 139.651 116.256 139.856 119.244 139.493C121.505 139.218 124.253 138.769 126.86 138.037L121.87 134.435L92.6575 131.316L91.5703 133.645L91.5721 133.643Z"
                    fill="#7196B5"/>
                <path
                    d="M191.563 92.1495V94.6319C192.074 95.7337 192.338 96.9419 192.338 98.1647V103.029C192.338 104.35 191.893 105.634 191.046 106.618C189.942 107.898 187.958 109.695 184.466 111.662L155.191 130.25C155.191 130.25 144.657 137.985 133.901 139.255L119.559 136.791L142.107 114.623L162.4 101.153L188.958 86.5469C188.958 86.5469 191.231 88.0484 191.563 92.1459V92.1495Z"
                    fill="#547B9B"/>
                <path
                    d="M189.842 85.7423C189.842 85.7423 191.505 81.5861 191.617 75.813C191.617 75.813 190.033 62.8458 183.33 62.7578L150.31 80.2588L141.82 84.4223L127.615 98.077L143.73 106.774L189.84 85.7423H189.842Z"
                    fill="url(#paint3_linear_3545_20718)"/>
                <path
                    d="M114.162 115.355L138.225 116.741L142.106 114.624L143.067 104.233L135.526 99.6914L125.472 103.772L111.057 105.234L114.162 115.355Z"
                    fill="url(#paint4_linear_3545_20718)"/>
                <path
                    d="M191.562 92.1498C191.562 92.1498 190.602 87.5317 188.9 88.2247L147.429 112.932L119.558 136.793L105.623 128.404L114.161 115.358L138.223 116.744C138.223 116.744 140.552 114.549 140.33 112.588L141.217 108.663L187.568 80.7227L189.342 84.0703C189.342 84.0703 192.004 87.187 191.561 92.1517L191.562 92.1498Z"
                    fill="url(#paint5_linear_3545_20718)"/>
                <path
                    d="M-14.5801 -9.33801C-14.5801 -9.33801 -0.608309 -5.52834 8.48503 4.16999L38.9789 47.5815C38.9789 47.5815 18.1687 43.7718 -17.8691 28.1848L-17.7041 22.8278C-17.3705 12.0442 -16.3273 1.29532 -14.5801 -9.33984V-9.33801Z"
                    fill="#4B6C8C"/>
                <path
                    d="M140.331 112.587C140.331 112.587 142.993 109.932 146.541 108.2C150.09 106.467 180.14 90.3044 187.237 84.1847C187.237 84.1847 188.234 83.2607 189.343 84.0692C189.343 84.0692 190.526 78.681 189.86 76.4499C189.195 74.2169 188.086 70.8307 186.091 71.2157C184.692 71.4852 176.037 77.6049 169.311 81.299C162.584 84.9932 153.047 88.6122 150.534 91.1514C147.681 94.0334 140.701 103.851 139.519 107.778C138.336 111.703 140.333 112.589 140.333 112.589L140.331 112.587Z"
                    fill="#547B9B"/>
                <path
                    d="M114.358 5.76412C114.358 5.76412 118.432 -1.20804 114.732 -5.10938L110.518 3.22863L114.357 5.76412H114.358Z"
                    fill="url(#paint6_linear_3545_20718)"/>
                <path
                    d="M105.769 -0.466071C105.769 -0.466071 104.999 -4.14374 110.557 -6.9689C111.368 -7.3814 112.314 -7.36674 113.1 -6.90657C114.756 -5.94224 116.591 -3.38107 111.668 3.17126L105.769 -0.466071Z"
                    fill="url(#paint7_linear_3545_20718)"/>
                <path d="M128.357 15.2538L105.371 3.71484L133.027 34.3278L134.087 19.41L128.357 15.2538Z"
                      fill="#2C3E54"/>
                <path
                    d="M14.0547 -0.180147L79.589 -22.6953C79.589 -22.6953 105.536 -6.29981 130.228 21.1012L122.687 29.4135L74.4869 51.1202L46.5432 48.504C46.5432 48.504 42.0717 40.3218 33.7905 27.5545C28.7177 19.7299 22.609 10.1012 14.0547 -0.180147Z"
                    fill="#4B6C8C"/>
                <g opacity="0.25">
                    <path
                        d="M41.0304 -9.44817L14.0547 -0.180667C22.609 10.1007 28.7177 19.7312 33.7924 27.5558C42.0735 40.3232 46.545 48.5053 46.545 48.5053L74.4887 51.1233L122.689 29.4167L130.229 21.1043C118.419 15.9912 68.2517 -12.1028 41.0322 -9.44633L41.0304 -9.44817Z"
                        fill="white"/>
                </g>
                <g opacity="0.25">
                    <path
                        d="M19.2889 -1.97852L14.0547 -0.180016C22.609 10.1013 28.7177 19.7318 33.7924 27.5565C42.0735 40.3238 46.545 48.506 46.545 48.506L74.4887 51.124L111.995 40.5365C100.379 36.0082 53.2404 3.88815 19.2889 -1.97852Z"
                        fill="white"/>
                </g>
                <path
                    d="M78.2343 -22.2296C82.2181 -19.3806 114.516 3.99986 128.651 22.841L130.229 21.1012C105.538 -6.29981 79.5891 -22.6953 79.5891 -22.6953L78.2324 -22.2296H78.2343Z"
                    fill="#37556D"/>
                <path
                    d="M37.317 45.9654C37.317 45.9654 4.67812 38.7292 -23.2655 24.7207C-23.2655 24.7207 -25.4839 30.4169 -25.6305 33.649C-25.6305 33.649 -25.7552 52.6075 -24.1547 62.0877C-23.8375 63.9687 -23.6835 65.8699 -23.656 67.7784L-23.5882 72.3415C-23.5699 73.535 -23.4489 74.7249 -23.2234 75.8964L-22.8219 77.9845L16.3473 95.403C19.0625 96.6112 21.6126 98.1714 23.9428 100.06C26.5058 102.135 30.2055 104.889 33.3606 106.311L37.3151 45.9654H37.317Z"
                    fill="url(#paint8_linear_3545_20718)"/>
                <path
                    d="M78.1596 91.5341C78.1596 91.5341 59.203 79.4762 48.4541 77.2854C45.9846 76.7831 43.4858 77.7107 41.8431 79.6944C39.8136 82.1492 37.1095 86.5144 35.2046 93.7524C34.64 95.8937 34.9993 98.1891 36.1763 100.041C36.6475 100.781 38.3415 101.826 39.1115 102.745L38.6861 109.081L33.364 106.311L31.9963 100.426C31.4151 97.9214 31.1273 95.3602 31.1475 92.7844C31.2281 82.4756 31.9596 55.0782 37.3185 45.9629L54.2108 47.8109L91.543 70.3261L94.5368 84.1806L78.1615 91.5322L78.1596 91.5341Z"
                    fill="url(#paint9_linear_3545_20718)"/>
                <path
                    d="M81.2656 89.2242L82.5508 85.6437L93.4628 81.2969L131.017 96.7097L135.527 99.6925L128.023 103.176L96.3466 104.773L81.2656 89.2242Z"
                    fill="url(#paint10_linear_3545_20718)"/>
                <path
                    d="M109.569 94.9807L107.935 95.1347C107.677 95.1586 107.416 95.1054 107.185 94.9807L100.116 91.1399L93.6371 88.0819C93.5014 88.0177 93.3951 87.8986 93.3437 87.7519L92.5976 85.6289C92.4986 85.3466 92.2529 85.1486 91.9651 85.1211L88.1829 84.7544L87.2754 72.5664L95.9086 82.8111L109.569 94.9807Z"
                    fill="url(#paint11_linear_3545_20718)"/>
                <path
                    d="M144.479 84.1382L141.289 91.8015C141.025 92.434 140.6 92.9803 140.059 93.3782L133.631 98.1027C133.026 98.5463 132.271 98.7058 131.548 98.5427L116.75 95.1877L109.569 94.9805C108.989 94.964 108.421 94.8045 107.911 94.5167L101.089 90.6557C101.027 90.6208 100.963 90.586 100.899 90.5548L94.3978 87.3685C94.2548 87.2988 94.1484 87.1668 94.1044 87.0092L93.5141 84.8843C93.4426 84.6295 93.2281 84.448 92.9733 84.4297L89.7906 84.2042C89.4588 84.1803 89.1856 83.9237 89.1288 83.5827L87.2734 72.5625L123.858 90.344L144.479 84.1345V84.1382Z"
                    fill="url(#paint12_linear_3545_20718)"/>
                <path
                    d="M87.2734 72.5664C87.2734 72.5664 91.7871 80.6111 96.8214 86.6556C98.5888 88.7767 97.5969 89.1049 102.431 90.1646C104.312 90.5771 107.735 92.5369 110.599 93.3271C111.532 93.5837 112.649 93.2629 113.668 93.5214C115.74 94.0457 117.839 95.1457 120.193 95.6187C123.286 96.2402 126.578 96.7847 129.961 97.1661C131.327 97.3201 132.685 96.7884 133.642 95.7617L144.481 84.1402C144.481 84.1402 127.858 84.7049 112.5 81.2986C112.5 81.2986 94.6471 76.6804 87.2753 72.5682L87.2734 72.5664Z"
                    fill="url(#paint13_linear_3545_20718)"/>
                <path d="M167.887 71.1367L173.541 75.6302L167.389 82.3366L159.738 75.6981L167.887 71.1367Z"
                      fill="url(#paint14_linear_3545_20718)"/>
                <path
                    d="M114.162 115.356L112.092 106.312L104.255 107.467L99.0078 124.246L105.622 128.404L114.162 115.356Z"
                    fill="#2C3E54"/>
                <path
                    d="M54.209 47.814C58.829 55.9302 65.7296 62.3762 73.9796 66.2775L87.2732 72.5659C101.087 79.0999 115.659 82.9719 131.093 83.7932L142.753 84.4752C143.349 84.51 143.936 84.3964 144.479 84.1379C149.192 81.881 172.974 70.3604 183.574 62.5797C184.706 61.7492 185.27 60.3137 185.045 58.891C184.643 56.372 183.776 52.1462 182.049 47.9955C180.087 43.2802 176.6 39.432 172.235 37.034C164.284 32.6652 145.811 22.7707 128.356 15.2559C128.356 15.2559 134.566 20.105 123.478 26.1092C112.39 32.1134 77.3475 45.7369 77.3475 45.7369C77.3475 45.7369 66.7765 48.738 54.209 47.8159V47.814Z"
                    fill="url(#paint15_linear_3545_20718)"/>
                <path opacity="0.2"
                      d="M131.093 83.794L141.819 84.4228C143.031 84.4943 144.232 84.2597 145.334 83.728C151.51 80.7525 173.158 70.1412 183.33 62.7583C184.608 61.8307 185.264 60.2357 185 58.637C184.69 56.7597 184.136 54.0445 183.198 51.1387C180.697 55.7403 178.919 57.0512 178.919 57.0512C169.613 64.368 148.924 74.0553 143.171 76.6862C142.201 77.1298 141.235 77.5497 140.232 77.9053C139.157 78.2867 138.012 78.6497 136.816 78.9962C136.594 79.0603 144.701 84.1075 144.478 84.1698C139.28 85.6273 124.923 81.7847 119.896 82.595C123.603 83.1707 127.338 83.5722 131.093 83.7922V83.794Z"
                      fill="url(#paint16_linear_3545_20718)"/>
                <path
                    d="M135.527 99.6928C135.527 99.6928 127.651 100.569 117.674 100.43C110.405 100.329 103.215 98.7578 96.5049 95.8428L81.2644 89.2227L76.7324 89.461L78.1588 91.5308C81.7191 94.136 84.4178 97.821 85.8881 102.085L92.4973 121.255C93.3553 123.742 92.3799 126.513 90.1818 127.833L90.1359 127.86L91.7621 132.786C91.7621 132.786 94.2719 133.397 98.0486 134.141C100.335 134.592 102.63 134.059 105.569 134.502C107.767 134.834 110.526 136.165 112.82 136.389C115.113 136.612 117.399 136.761 119.559 136.788C119.559 134.579 118.19 132.629 116.164 131.974C113.247 131.032 108.838 129.351 104.502 126.711C102.894 125.732 102.175 123.702 102.714 121.847L107.307 116.305L105.644 111.767C106.284 109.569 108.104 107.965 110.292 107.675L121.693 106.157C124.768 105.748 127.725 104.665 130.367 102.978L135.524 99.6873L135.527 99.6928Z"
                    fill="url(#paint17_linear_3545_20718)"/>
                <path
                    d="M72.703 86.8755C66.686 83.2363 57.9648 78.884 47.9621 76.7225C45.6613 76.2256 43.2963 77.0891 41.7581 78.9371C39.3216 81.8631 35.9905 87.2275 34.489 95.8203C34.291 96.957 34.566 98.1285 35.2058 99.0726C36.3535 100.767 38.1923 103.374 39.0356 103.986C39.0356 103.986 39.5178 92.8063 44.301 85.2951C45.3515 83.6451 47.3296 82.9338 49.1556 83.4838C53.365 84.7525 61.6645 87.5758 70.1876 92.3113L72.7048 86.8755H72.703Z"
                    fill="#7196B5"/>
                <path
                    d="M74.1835 95.5516C74.1835 95.5516 77.4688 97.6141 78.4148 99.8655L91.767 134.446L98.2038 134.284C98.2038 134.284 89.49 109.258 84.397 98.4446C82.6718 94.7835 76.7483 89.4668 76.7483 89.4668L74.1816 95.5516H74.1835Z"
                    fill="#7196B5"/>
                <path
                    d="M37.3168 45.9662L16.9649 16.9409C13.1864 11.5509 9.10911 5.66404 4.19945 1.47487C-1.57739 -3.45129 -8.37906 -6.42679 -15.3586 -9.39496C-26.0341 -13.9343 -39.8482 -19.4618 -54.0327 -24.1991C-59.3127 -25.9628 -65.0291 -25.6603 -70.1441 -23.4346L-72.2029 -22.54C-72.2029 -22.54 -78.7076 -25.1561 -83.5879 -29.3141L-70.6501 -36.4531C-70.6501 -36.4531 -10.7716 -21.539 14.0298 -0.101795C14.0298 -0.101795 20.408 8.36821 29.6021 21.8835C34.3889 28.918 39.7129 37.0727 45.3651 46.716C45.3651 46.716 41.6544 46.4557 37.3149 45.9662H37.3168Z"
                    fill="url(#paint18_linear_3545_20718)"/>
                <path
                    d="M112.499 81.2964C112.499 81.2964 105.993 79.6115 99.2129 77.373L100.841 81.1937C101.637 83.0619 103.189 84.4662 105.081 85.0107C111.768 86.9375 128.158 91.189 139.009 90.0047L144.48 84.138C144.48 84.138 127.857 84.7027 112.499 81.2964Z"
                    fill="#4B6C8C"/>
                <path
                    d="M144.479 84.139L135.826 85.6204L120.033 82.665L126.296 81.4917C126.727 81.4165 127.167 81.4642 127.574 81.6292L131.803 83.3397C132.045 83.4369 132.3 83.4937 132.559 83.5084L144.479 84.1409V84.139Z"
                    fill="url(#paint19_linear_3545_20718)"/>
                <path
                    d="M54.209 47.8145L97.1585 60.7578L105.823 70.6358L94.59 62.7671L74.1978 66.322L72.7055 65.4475C65.3208 61.1263 58.994 55.0928 54.2108 47.8145H54.209Z"
                    fill="url(#paint20_linear_3545_20718)"/>
                <path
                    d="M74.1953 66.3205L94.5875 62.7656L105.807 70.605L107.767 75.6136L119.191 79.658L120.036 82.661C120.036 82.661 113.823 82.1916 99.1818 77.5753C89.3093 74.4623 78.8043 69.3895 74.1953 66.3186V66.3205Z"
                    fill="url(#paint21_linear_3545_20718)"/>
                <path
                    d="M113.668 93.5198L119.263 90.57L122.054 94.4695L132.439 89.9448L126.609 86.2305L120.64 86.4505L113.668 93.5198Z"
                    fill="white"/>
                <path
                    d="M106.771 84.6523L102.884 86.438L105.028 87.835L102.432 90.1652L103.572 90.5153L107.341 88.2823L105.398 86.3188L109.714 85.8422L106.771 84.6523Z"
                    fill="url(#paint22_linear_3545_20718)"/>
                <path
                    d="M103.576 90.5135L107.344 88.2805L105.4 86.317L108.53 85.9668L115.377 87.6571L114.303 90.1706L110.413 90.3558L110.6 93.324C110.6 93.324 109.305 92.9536 106.805 91.8848C105.908 91.5016 104.551 90.8966 103.574 90.5135H103.576Z"
                    fill="#E3F1FE"/>
                <path
                    d="M115.386 87.6376L116.481 85.0801L108.537 85.9674C110.521 86.4936 112.855 87.0784 115.386 87.6394V87.6376Z"
                    fill="#89A6BD"/>
                <path d="M126.868 81.4411L118.896 79.5527L120.04 82.6621L126.868 81.4411Z"
                      fill="url(#paint23_linear_3545_20718)"/>
                <path
                    d="M68.5154 91.4152L67.5547 83.9316L72.8219 77.2051L77.792 80.8956L81.4679 77.7917L88.1614 81.6197L88.5243 83.5172L82.1315 81.4822L78.8517 83.9994L73.7825 82.0689L70.8895 85.6641L70.6549 92.7921L68.5154 91.4152Z"
                    fill="url(#paint24_linear_3545_20718)"/>
                <path
                    d="M82.131 81.4824L78.8511 83.9996L73.782 82.0691L70.889 85.6643L70.6543 92.7923L75.2816 92.8839L76.741 89.4611L81.2656 89.2246L82.5526 85.6789L88.181 84.7549L88.0783 83.3763L82.131 81.4824Z"
                    fill="#F09063"/>
                <path
                    d="M72.8202 77.2044L63.8717 69.5722L59.5139 69.3559L49.4141 61.6504L49.7184 65.3757L59.0941 72.0546L62.2181 71.7979L72.8202 77.2044Z"
                    fill="url(#paint25_linear_3545_20718)"/>
                <path d="M-40.0801 53.9746L30.9414 94.5371L31.2219 98.3468L-40.0801 53.9746Z"
                      fill="url(#paint26_linear_3545_20718)"/>
                <path d="M49.7188 65.376L32.9199 62.7764L33.6936 57.5605L49.4144 61.6507L49.7188 65.376Z"
                      fill="url(#paint27_linear_3545_20718)"/>
                <path
                    d="M37.3169 45.9668L34.8529 57.8761L36.9888 63.4091L33.9656 68.6525C33.5036 69.4536 33.2359 70.3593 33.1864 71.2906L31.8646 95.7363C31.7894 97.115 31.8829 98.4991 32.1396 99.854L33.3624 106.315L32.8729 106.08L31.0891 99.711C30.6143 98.0188 30.4034 96.257 30.4658 94.4951L31.2486 71.9011C31.2944 70.5958 31.4594 69.2978 31.7454 68.0255L32.4109 65.061C32.7501 63.5448 32.9224 61.992 32.9206 60.4355C32.9169 57.5296 33.5164 54.6568 34.6733 52.0113L37.3188 45.9686L37.3169 45.9668Z"
                    fill="#2C3E54"/>
                <path d="M105.646 111.774L97.4727 105.748L102.714 121.852L107.308 116.312L105.646 111.774Z"
                      fill="#F09063"/>
                <path d="M32.8722 106.078L30.6722 98.0023L-14.3527 76.6935L-44.2012 68.625L32.8722 106.078Z"
                      fill="url(#paint28_linear_3545_20718)"/>
                <path
                    d="M-57.1348 65.3867L-56.4711 71.0114C-56.2199 73.1417 -54.7863 74.9641 -52.7916 75.5086C-52.7769 75.5122 -52.7641 75.5159 -52.7494 75.5196C-44.6608 77.6756 -36.7353 80.4586 -29.0389 83.8447L38.3324 113.002L38.8311 107.403L34.0717 105.258C30.4326 103.617 27.0684 101.381 24.1094 98.6287C21.2091 95.9337 17.9201 93.7282 14.3616 92.0984L-38.5704 67.8306C-41.0399 66.6976 -43.8101 66.4867 -46.4116 67.2311C-48.9324 67.9534 -51.6146 67.7774 -54.0291 66.7324L-57.1348 65.3867Z"
                    fill="#2C3E54"/>
                <path
                    d="M54.209 47.8145C54.209 47.8145 71.809 68.214 99.1843 77.5768C99.1843 77.5768 64.6333 68.049 54.209 47.8145Z"
                    fill="#4B6C8C"/>
                <path
                    d="M79.6465 68.4375L93.4497 72.5662L99.1825 77.5767C99.1825 77.5767 89.3705 74.6378 82.8108 71.2993C81.3643 70.5642 80.0517 68.9967 79.6465 68.4375Z"
                    fill="url(#paint29_linear_3545_20718)"/>
                <path d="M78.8613 68.9395L93.4492 72.564L99.182 77.5764L94.2577 71.8839L74.6465 65.623L78.8613 68.9395Z"
                      fill="#4B6C8C"/>
                <path
                    d="M99.1835 77.5769L102.428 77.2285L106.321 78.9207C107.672 79.5074 109.067 79.9785 110.491 80.3269L120.039 82.6625C120.039 82.6625 111.186 81.8559 99.1816 77.5769H99.1835Z"
                    fill="url(#paint30_linear_3545_20718)"/>
                <path
                    d="M128.459 88.4509L122.591 90.7719L123.335 86.2546L124.529 85.3599L121.425 84.9199L113.668 93.5183L120.136 88.6581L122.244 92.6529L128.459 88.4509Z"
                    fill="url(#paint31_linear_3545_20718)"/>
                <path d="M105.809 70.6055L124.342 71.084L144.591 84.0438L121.737 74.2905L105.809 70.6055Z"
                      fill="url(#paint32_linear_3545_20718)"/>
                <path d="M118.899 79.554L121.737 74.2905L105.809 70.6055L107.768 75.6141L118.899 79.554Z"
                      fill="url(#paint33_linear_3545_20718)"/>
                <path d="M124.341 71.084L121.736 74.2905L144.479 84.1373L124.341 71.084Z"
                      fill="url(#paint34_linear_3545_20718)"/>
                <path
                    d="M-72.0546 -22.4664C-72.0546 -22.4664 -68.4228 -24.879 -64.703 -26.3072C-62.2903 -27.2349 -59.654 -27.2935 -57.1826 -26.5455C-47.1836 -23.5169 -10.9771 -12.1282 3.33387 -1.82303C3.33387 -1.82303 13.6042 4.31681 37.3037 45.9573C37.3037 45.9573 42.6607 46.7695 45.7737 46.8886C45.7737 46.8886 26.8555 14.1471 13.1184 -1.20703C10.0035 -4.69036 6.32037 -7.54119 2.23936 -9.68802C-6.51846 -14.297 -27.039 -24.0614 -57.0525 -32.0107C-60.4533 -32.9109 -64.043 -32.6249 -67.2586 -31.16C-70.1901 -29.8254 -73.9045 -27.7592 -77.4043 -24.7342L-72.0528 -22.4645L-72.0546 -22.4664Z"
                    fill="#37556D"/>
                <path
                    d="M26.8792 42.0037C26.8792 42.0037 26.738 38.403 25.484 34.9289C24.23 31.4547 21.1463 29.5059 17.7583 29.7442C13.9982 30.0082 8.24335 30.7085 3.42535 32.573C3.42535 32.573 1.94402 33.4072 1.41602 37.2517C1.41602 37.2517 1.51502 39.9962 12.7955 41.4794C12.7955 41.4794 25.4694 43.4429 26.881 42.0037H26.8792Z"
                    fill="url(#paint35_linear_3545_20718)"/>
                <path
                    d="M23.3774 50.7141C24.1291 51.0643 25.0677 51.4566 26.0302 51.7481C27.8911 52.311 29.9114 51.3906 30.5677 49.4931C30.8134 48.78 30.9216 47.9055 30.7566 46.8403L26.8791 42.004C26.8791 42.004 4.61873 41.6703 1.41406 37.252V39.5143C1.41406 40.2916 1.6634 41.0543 2.15473 41.6391C2.87706 42.5008 4.12923 43.6228 5.8984 43.9216C11.2352 44.8236 16.5024 44.7558 18.9499 45.4231C20.2277 45.7715 20.4019 47.2235 21.0399 48.45C21.5606 49.451 22.3764 50.2503 23.3756 50.7141H23.3774Z"
                    fill="url(#paint36_linear_3545_20718)"/>
                <path
                    d="M26.8791 42.004C26.8791 42.004 4.61873 41.6703 1.41406 37.252V38.7131C2.81656 40.0166 6.99473 42.8235 17.3402 43.3423C17.3402 43.3423 22.9246 43.3808 25.3482 45.3993C26.8461 46.6478 28.5126 49 29.7024 50.8516C30.0746 50.4813 30.3807 50.0321 30.5677 49.4913C30.8134 48.7781 30.9216 47.9036 30.7566 46.8385L26.8791 42.0021V42.004Z"
                    fill="url(#paint37_linear_3545_20718)"/>
            </g>
        </g>
        <defs>
            <linearGradient id="paint0_linear_3545_20718" x1="82.4992" y1="261.159" x2="82.4992" y2="39.6706"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#ECFFFF"/>
                <stop offset="0.3" stop-color="#E8FAFF"/>
                <stop offset="0.66" stop-color="#DEEBFF"/>
                <stop offset="1" stop-color="#CFD7FF"/>
            </linearGradient>
            <linearGradient id="paint1_linear_3545_20718" x1="82.2323" y1="-15.1096" x2="82.2323" y2="76.4874"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#ECFFFF"/>
                <stop offset="0.46" stop-color="#F0FCFF"/>
                <stop offset="1" stop-color="#FFF4FF"/>
            </linearGradient>
            <linearGradient id="paint2_linear_3545_20718" x1="45.6872" y1="119.319" x2="79.833" y2="119.319"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint3_linear_3545_20718" x1="149.21" y1="65.9276" x2="183.576" y2="128.884"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint4_linear_3545_20718" x1="127.062" y1="115.702" x2="127.062" y2="70.8659"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint5_linear_3545_20718" x1="105.623" y1="108.756" x2="191.612" y2="108.756"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint6_linear_3545_20718" x1="110.519" y1="0.326458" x2="116.285" y2="0.326458"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint7_linear_3545_20718" x1="118.063" y1="-5.12824" x2="75.7093" y2="14.5361"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint8_linear_3545_20718" x1="-25.6324" y1="65.516" x2="37.317" y2="65.516"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint9_linear_3545_20718" x1="31.1438" y1="77.5256" x2="94.535" y2="77.5256"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint10_linear_3545_20718" x1="123.408" y1="90.8815" x2="163.443" y2="86.597"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint11_linear_3545_20718" x1="90.1941" y1="83.7002" x2="144.65" y2="84.8351"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.02" stop-color="#D4530D"/>
                <stop offset="0.06" stop-color="#DD6627"/>
                <stop offset="0.11" stop-color="#E4753D"/>
                <stop offset="0.17" stop-color="#E9814E"/>
                <stop offset="0.24" stop-color="#ED895A"/>
                <stop offset="0.34" stop-color="#EF8E61"/>
                <stop offset="0.61" stop-color="#F09063"/>
                <stop offset="0.66" stop-color="#E7906B"/>
                <stop offset="0.75" stop-color="#D19382"/>
                <stop offset="0.86" stop-color="#AC97A7"/>
                <stop offset="0.99" stop-color="#7A9CDA"/>
                <stop offset="1" stop-color="#769DDF"/>
            </linearGradient>
            <linearGradient id="paint12_linear_3545_20718" x1="90.1628" y1="85.1795" x2="144.618" y2="86.3125"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.02" stop-color="#D4530D"/>
                <stop offset="0.06" stop-color="#DD6627"/>
                <stop offset="0.11" stop-color="#E4753D"/>
                <stop offset="0.17" stop-color="#E9814E"/>
                <stop offset="0.24" stop-color="#ED895A"/>
                <stop offset="0.34" stop-color="#EF8E61"/>
                <stop offset="0.61" stop-color="#F09063"/>
                <stop offset="0.66" stop-color="#E7906B"/>
                <stop offset="0.75" stop-color="#D19382"/>
                <stop offset="0.86" stop-color="#AC97A7"/>
                <stop offset="0.99" stop-color="#7A9CDA"/>
                <stop offset="1" stop-color="#769DDF"/>
            </linearGradient>
            <linearGradient id="paint13_linear_3545_20718" x1="87.2734" y1="84.8772" x2="144.479" y2="84.8772"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint14_linear_3545_20718" x1="174.652" y1="71.8921" x2="158.515" y2="82.2614"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint15_linear_3545_20718" x1="238.893" y1="29.0462" x2="34.7702" y2="70.2889"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint16_linear_3545_20718" x1="82.9512" y1="93.7288" x2="306.381" y2="21.7064"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint17_linear_3545_20718" x1="76.7343" y1="113.01" x2="135.527" y2="113.01"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint18_linear_3545_20718" x1="-83.5879" y1="5.13237" x2="45.3669" y2="5.13237"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint19_linear_3545_20718" x1="90.2159" y1="82.6834" x2="144.67" y2="83.8182"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.02" stop-color="#D4530D"/>
                <stop offset="0.06" stop-color="#DD6627"/>
                <stop offset="0.11" stop-color="#E4753D"/>
                <stop offset="0.17" stop-color="#E9814E"/>
                <stop offset="0.24" stop-color="#ED895A"/>
                <stop offset="0.34" stop-color="#EF8E61"/>
                <stop offset="0.61" stop-color="#F09063"/>
                <stop offset="0.66" stop-color="#E7906B"/>
                <stop offset="0.75" stop-color="#D19382"/>
                <stop offset="0.86" stop-color="#AC97A7"/>
                <stop offset="0.99" stop-color="#7A9CDA"/>
                <stop offset="1" stop-color="#769DDF"/>
            </linearGradient>
            <linearGradient id="paint20_linear_3545_20718" x1="67.5868" y1="57.9253" x2="166.066" y2="68.2195"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint21_linear_3545_20718" x1="45.7786" y1="73.4448" x2="153.819" y2="72.1633"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#4B6C8C"/>
                <stop offset="0.03" stop-color="#507196"/>
                <stop offset="0.1" stop-color="#5E81B0"/>
                <stop offset="0.18" stop-color="#698EC6"/>
                <stop offset="0.27" stop-color="#7298D7"/>
                <stop offset="0.39" stop-color="#789EE3"/>
                <stop offset="0.55" stop-color="#7CA2EA"/>
                <stop offset="1" stop-color="#7DA4EC"/>
            </linearGradient>
            <linearGradient id="paint22_linear_3545_20718" x1="113.881" y1="86.5388" x2="170.606" y2="79.7317"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint23_linear_3545_20718" x1="118.381" y1="81.1899" x2="147.245" y2="78.9991"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#4B6C8C"/>
                <stop offset="0.03" stop-color="#507196"/>
                <stop offset="0.1" stop-color="#5E81B0"/>
                <stop offset="0.18" stop-color="#698EC6"/>
                <stop offset="0.27" stop-color="#7298D7"/>
                <stop offset="0.39" stop-color="#789EE3"/>
                <stop offset="0.55" stop-color="#7CA2EA"/>
                <stop offset="1" stop-color="#7DA4EC"/>
            </linearGradient>
            <linearGradient id="paint24_linear_3545_20718" x1="77.5885" y1="82.2559" x2="36.9985" y2="101.29"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.03" stop-color="#C45519"/>
                <stop offset="0.08" stop-color="#B0643E"/>
                <stop offset="0.14" stop-color="#9F725E"/>
                <stop offset="0.2" stop-color="#907D79"/>
                <stop offset="0.27" stop-color="#85868F"/>
                <stop offset="0.35" stop-color="#7B8DA0"/>
                <stop offset="0.46" stop-color="#7592AC"/>
                <stop offset="0.6" stop-color="#7295B3"/>
                <stop offset="0.99" stop-color="#7196B5"/>
            </linearGradient>
            <linearGradient id="paint25_linear_3545_20718" x1="71.2839" y1="70.1791" x2="35.4844" y2="67.5317"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.02" stop-color="#D4530D"/>
                <stop offset="0.06" stop-color="#DD6627"/>
                <stop offset="0.11" stop-color="#E4753D"/>
                <stop offset="0.17" stop-color="#E9814E"/>
                <stop offset="0.24" stop-color="#ED895A"/>
                <stop offset="0.34" stop-color="#EF8E61"/>
                <stop offset="0.61" stop-color="#F09063"/>
                <stop offset="0.66" stop-color="#E7906B"/>
                <stop offset="0.75" stop-color="#D19382"/>
                <stop offset="0.86" stop-color="#AC97A7"/>
                <stop offset="0.99" stop-color="#7A9CDA"/>
                <stop offset="1" stop-color="#769DDF"/>
            </linearGradient>
            <linearGradient id="paint26_linear_3545_20718" x1="-38.3879" y1="71.1474" x2="256.258" y2="114.647"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint27_linear_3545_20718" x1="71.7628" y1="63.6912" x2="35.9651" y2="61.0439"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.02" stop-color="#D4530D"/>
                <stop offset="0.06" stop-color="#DD6627"/>
                <stop offset="0.11" stop-color="#E4753D"/>
                <stop offset="0.17" stop-color="#E9814E"/>
                <stop offset="0.24" stop-color="#ED895A"/>
                <stop offset="0.34" stop-color="#EF8E61"/>
                <stop offset="0.61" stop-color="#F09063"/>
                <stop offset="0.66" stop-color="#E7906B"/>
                <stop offset="0.75" stop-color="#D19382"/>
                <stop offset="0.86" stop-color="#AC97A7"/>
                <stop offset="0.99" stop-color="#7A9CDA"/>
                <stop offset="1" stop-color="#769DDF"/>
            </linearGradient>
            <linearGradient id="paint28_linear_3545_20718" x1="0.361664" y1="77.4378" x2="-44.7163" y2="151.6"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint29_linear_3545_20718" x1="90.4155" y1="73.0282" x2="144.871" y2="74.163"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.02" stop-color="#D4530D"/>
                <stop offset="0.06" stop-color="#DD6627"/>
                <stop offset="0.11" stop-color="#E4753D"/>
                <stop offset="0.17" stop-color="#E9814E"/>
                <stop offset="0.24" stop-color="#ED895A"/>
                <stop offset="0.34" stop-color="#EF8E61"/>
                <stop offset="0.61" stop-color="#F09063"/>
                <stop offset="0.66" stop-color="#E7906B"/>
                <stop offset="0.75" stop-color="#D19382"/>
                <stop offset="0.86" stop-color="#AC97A7"/>
                <stop offset="0.99" stop-color="#7A9CDA"/>
                <stop offset="1" stop-color="#769DDF"/>
            </linearGradient>
            <linearGradient id="paint30_linear_3545_20718" x1="97.2181" y1="82.1804" x2="235.34" y2="59.2087"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.03" stop-color="#D4530D"/>
                <stop offset="0.1" stop-color="#DD6627"/>
                <stop offset="0.18" stop-color="#E4753D"/>
                <stop offset="0.27" stop-color="#E9814E"/>
                <stop offset="0.39" stop-color="#ED895A"/>
                <stop offset="0.55" stop-color="#EF8E61"/>
                <stop offset="1" stop-color="#F09063"/>
            </linearGradient>
            <linearGradient id="paint31_linear_3545_20718" x1="114.26" y1="89.6958" x2="170.983" y2="82.8886"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint32_linear_3545_20718" x1="104.019" y1="74.659" x2="186.395" y2="82.5185"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.07" stop-color="#8DB1EF" stop-opacity="0.8"/>
                <stop offset="0.15" stop-color="#9BBDF3" stop-opacity="0.61"/>
                <stop offset="0.23" stop-color="#A9C7F6" stop-opacity="0.45"/>
                <stop offset="0.32" stop-color="#B4D0F9" stop-opacity="0.31"/>
                <stop offset="0.42" stop-color="#BDD8FB" stop-opacity="0.2"/>
                <stop offset="0.52" stop-color="#C4DDFC" stop-opacity="0.11"/>
                <stop offset="0.64" stop-color="#C9E1FE" stop-opacity="0.05"/>
                <stop offset="0.78" stop-color="#CCE4FE" stop-opacity="0.01"/>
                <stop offset="1" stop-color="#CDE5FF" stop-opacity="0"/>
            </linearGradient>
            <linearGradient id="paint33_linear_3545_20718" x1="106.522" y1="85.2098" x2="124.914" y2="53.2585"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint34_linear_3545_20718" x1="119.76" y1="70.3342" x2="144.699" y2="86.9276"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.07" stop-color="#8DB1EF" stop-opacity="0.8"/>
                <stop offset="0.15" stop-color="#9BBDF3" stop-opacity="0.61"/>
                <stop offset="0.23" stop-color="#A9C7F6" stop-opacity="0.45"/>
                <stop offset="0.32" stop-color="#B4D0F9" stop-opacity="0.31"/>
                <stop offset="0.42" stop-color="#BDD8FB" stop-opacity="0.2"/>
                <stop offset="0.52" stop-color="#C4DDFC" stop-opacity="0.11"/>
                <stop offset="0.64" stop-color="#C9E1FE" stop-opacity="0.05"/>
                <stop offset="0.78" stop-color="#CCE4FE" stop-opacity="0.01"/>
                <stop offset="1" stop-color="#CDE5FF" stop-opacity="0"/>
            </linearGradient>
            <linearGradient id="paint35_linear_3545_20718" x1="7.76485" y1="35.444" x2="70.1202" y2="38.7349"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint36_linear_3545_20718" x1="12.8284" y1="44.3946" x2="93.2549" y2="55.93"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint37_linear_3545_20718" x1="-8.5116" y1="41.5346" x2="33.1252" y2="45.8888"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.29" stop-color="#A7C4F2"/>
                <stop offset="0.6" stop-color="#CFE3F9"/>
                <stop offset="0.85" stop-color="#E8F6FD"/>
                <stop offset="1" stop-color="#F2FEFF"/>
            </linearGradient>
            <clipPath id="clip0_3545_20718">
                <rect width="165" height="165" rx="8" fill="white"/>
            </clipPath>
        </defs>
    </svg>
);
